import React, { createContext, useContext, useState, useEffect } from 'react';
import { parsePrice } from '../utils/price';

const StoreContext = createContext();

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};

export const StoreProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // Sayfa yüklendiğinde localStorage'dan sepeti yükle
  useEffect(() => {
    const savedCart = localStorage.getItem('fb-cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  // Sepet değiştiğinde localStorage'a kaydet
  useEffect(() => {
    localStorage.setItem('fb-cart', JSON.stringify(cart));
  }, [cart]);

  // Sayfa kapatıldığında sepeti temizle
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('fb-cart');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  const addToCart = (product) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.id === product.id);
      
      if (existingItem) {
        // Ürün zaten sepette varsa miktarını artır
        return prevCart.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        // Yeni ürün ekle
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      return; // Quantity 0'a düşerse hiçbir şey yapma
    }
    
    setCart(prevCart =>
      prevCart.map(item =>
        item.id === productId
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem('fb-cart');
  };

  // Eski hesap ondalık ayıracını da siliyordu: "£45.00" → 4500, yani toplam 100 kat
  // fazla çıkıyor ve sipariş e-postasına öyle yazılıyordu. parsePrice bunu düzeltir.
  const getCartTotal = () => {
    return cart.reduce((total, item) => total + parsePrice(item.price) * item.quantity, 0);
  };

  const getCartCount = () => {
    return cart.reduce((count, item) => count + item.quantity, 0);
  };

  const value = {
    cart,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getCartCount
  };

  return (
    <StoreContext.Provider value={value}>
      {children}
    </StoreContext.Provider>
  );
};

export { StoreContext }; 